import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import * as JWT from 'jwt-decode';
import { Router } from '@angular/router';
import {HttpEvent,HttpHandler,HttpInterceptor,HttpRequest,HttpErrorResponse} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private cookieService: CookieService,
        private router: Router
      ) {}
    
      private handleAuthError(err: HttpErrorResponse): Observable<any> {
        // handle your auth error or rethrow
        if (err.status === 401 || err.status === 403) {
          // navigate / delete cookies or whatever
          this.router.navigateByUrl('/signin');
          // if you've caught / handled the error, you don't want to rethrow it
          // unless you want downstream consumers to handle it as well.
          return of(err.message);
        }
    
        return throwError(err);
      }
    
      intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        /* const token = JWT(this.cookieService.get('auth_token'));
        console.log(token); */
    
        if (!req.url.includes('//jsonip.com')) {
          req = req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + this.cookieService.get('auth_token'),
            },
          });
        }
    
        // ✅ RxJS 6 style: use pipe + catchError
        return next.handle(req).pipe(
          catchError(err => this.handleAuthError(err))
        );
      }
    }
